require('./_set-species')('Array');


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/~/core-js/modules/es6.array.species.js
// module id = ../../../../core-js/modules/es6.array.species.js
// module chunks = 3